//configuration
import headquartersView from "./Configuration/Headquarters.vue";
import journeysView from "./Configuration/Journeys.vue";
import periodsView from "./Configuration/Periods.vue";
import identityView from "./Configuration/Identity.vue";
import parametersView from "./Configuration/Parameters.vue";
import categoriesView from "./Configuration/Categories.vue";
import academicYearView from "./Configuration/AcademicYear.vue";
import countriesView from "./Location/Countries.vue";
import departmentsView from "./Location/Departments.vue";
import statesView from "./Location/States.vue";
import schoolLegalEntityView from "./Configuration/SchoolLegalEntity.vue";
import foliosEnrollmentView from "./Configuration/FoliosEnrollment.vue";
import foliosEnrollmentEdit from "./Configuration/Components/FoliosEnrollmentEdit.vue";

// Aula
import teachersView from "./Aula/Teachers.vue";
import studentsView from "./Aula/Students.vue";
import teacherTabs from "./Aula/components/Teachers/TeacherTabs.vue";
import studentTabs from "./Aula/components/Students/StudentTabs.vue";
import coursesView from "./Aula/Courses.vue";
import coursesTab from "./Aula/components/AddCourse.vue";
import myGroupsView from "./Aula/MyGroups.vue";
import ScoreGroupsPanel from "./Aula/components/ScoreGroupsPanel.vue";
import StudentAttendance from "./Aula/StudentAttendance.vue";
import StudentAttendanceList from "./Aula/components/StudentAttendanceList.vue";


//Security
import dutiesView from "./Security/Duties.vue";
import usersView from "./Security/Users.vue";
import usersEditView from "./Security/components/AddUser.vue";
import permissionsView from "./Security/DutyPermissions.vue";

// Template
import templateView from "./Template/Templates.vue";
import templateEditView from "./Template/components/TemplateEdit.vue";

//administration
import menuView from "./Administration/Menu.vue";
import routesView from "./Administration/Routes.vue";

//Matriculas
import enrollments from "./Enrollment/Enrollments.vue";
import enrollmentDetail from "./Enrollment/components/IndividualEnrollment.vue";
import enrollmentGroup from "./Enrollment/components/EnrollmentGroup.vue";

//Collection
import tuitionDiscounts from "./Collection/TuitionDiscounts.vue";
import tuitionPriceLists from "./Collection/TuitionPriceLists.vue";
import tuitionPriceLines from "./Collection/TuitionPriceLines.vue";
import payments from "./Collection/Payments.vue";
import enrollmentCharge from "./Collection/EnrollmentCharge.vue";
import EnrollmentAppliedDiscounts from "./Collection/EnrollmentAppliedDiscounts.vue";
import FiscalPeriods from "./Collection/FiscalPeriods.vue";
import AccountReceivable from "./Collection/EnrollmentCollection.vue";
import CollectionAccount from "./Collection/components/CollectionAccount.vue";

//academic
import systemEvaluationMetricsView from "./Academic/SystemEvaluationMetrics.vue";
import systemSubjects from "./Academic/SystemSubjects.vue";
import systemAcademicAssignmentsView from "./Academic/components/SystemAcademicAssignmentsContent.vue";
import systemAreasView from "./Academic/components/SystemAreasContent.vue";
import AcademicAssignmentEdit from "./Academic/components/AcademicAssignmentEdit.vue";

//academic-base
import saberTypesView from "./AcademicBase/SaberTypes.vue";
import saberWeightsView from "./AcademicBase/SaberWeights.vue";
import AcademicPerformanceGrades from "./AcademicBase/AcademicPerformanceGrades.vue";
import Competencies from "./AcademicBase/Competencies.vue";
import CompetencyTabContent from "./AcademicBase/Components/CompetencyTabContent.vue";
import CompetencyPeriodAssigmentContent from "./AcademicBase/Components/CompetencyPeriodAssigmentContent.vue";
import PerformancesContent from "./AcademicBase/Components/PerformancesContent.vue";

//preschool
import PreschoolDimensionsView from "./Preschool/PreschoolDimensionsView.vue";
import PreschoolPerformancesView from "./Preschool/PreschoolPerformancesView.vue";
import PreschoolTeacherAssigmentView from "./Preschool/PreschoolAcademicAssignments.vue";
import PreschoolTeacherAssigmentEdit from "./Preschool/components/PreschoolAssignmentEdit.vue";
import PreschoolMyGroupsContent from "./Preschool/PrescholMyGroups.vue";
import PreschoolScoresContent from "./Preschool/components/PreschoolScoresContent.vue";
import PreschoolDimensionEdit from "./Preschool/components/DimensionTabContent.vue";

//Piar
import Piar from "./Piar/Piar.vue";
import PiarTabContent from "./Piar/components/PiarTabContent.vue";

//Reports
import PreschoolScoreReport from "./Reports/PreschoolScoreReport.vue";


export default {
  //configuration
  headquartersView,
  journeysView,
  periodsView,
  identityView,
  parametersView,
  countriesView,
  departmentsView,
  statesView,
  categoriesView,
  academicYearView,
  schoolLegalEntityView,
  foliosEnrollmentView,
  foliosEnrollmentEdit,

  //Aula
  teachersView,
  studentsView,
  teacherTabs,
  studentTabs,
  coursesView,
  coursesTab,
  myGroupsView,
  ScoreGroupsPanel,
  StudentAttendance,
  StudentAttendanceList,

  //Security
  dutiesView,
  usersView,
  usersEditView,
  permissionsView,

  // Template
  templateView,
  templateEditView,

  //administration
  menuView,
  routesView,

  //enrollments
  enrollments,
  enrollmentDetail,
  enrollmentGroup,

  //Collection
  tuitionDiscounts,
  tuitionPriceLists,
  tuitionPriceLines,
  payments,
  enrollmentCharge,
  EnrollmentAppliedDiscounts,
  FiscalPeriods,
  AccountReceivable,
  CollectionAccount,

  //academic
  systemEvaluationMetricsView,
  systemSubjects,
  systemAcademicAssignmentsView,
  systemAreasView,
  AcademicAssignmentEdit,

  //academic-base
  saberTypesView,
  saberWeightsView,
  AcademicPerformanceGrades,
  Competencies,
  CompetencyTabContent,
  CompetencyPeriodAssigmentContent,
  PerformancesContent,

  //preschool
  PreschoolDimensionsView,
  PreschoolPerformancesView,
  PreschoolTeacherAssigmentView,
  PreschoolTeacherAssigmentEdit,
  PreschoolMyGroupsContent,
  PreschoolScoresContent,
  PreschoolDimensionEdit,

  //Piar
  Piar,
  PiarTabContent,

  //Reports
  PreschoolScoreReport

};
